export { default } from './CustomVideoControls';
